import { settings as settings } from '../environments/settings';
export const environment = {
  ...settings,
  template: 'pwa-1.1',
  theme: {
    name: 'CDA',
    appName: 'Coeur d` Alene',
    productionHostName: 'cda-trueomni.web.app',
    stagingHostName: 'staging-cda.web.app',
    appCode: 'CDA'
  },
  cms: {
    domainId: 1082,
    accountId: 1082,
    channelId: 1422,
    deviceId: 1055,
    formId: 158,
    postalCode: '83814',
    bandwangosPageId: 3388,
    visitorCenterId: 18004,
    main_coordinates: {
      latitude: settings.site.latitude,
      longitude: settings.site.longitude,
    },
    navigation: {
      avatar_enabled: false,
      homePageId: 4424,
      itemsPerRowCategory: 2,
      footerPageId: 0
    }
  },
  regions:{
    enabled: true,
    regionsPageId: 6977,
    defaultRegion: null
  },
  coreAuthLib: {
    base_url: 'https://usersapi.mobimanage.com',
    client_secret: 'pcKEyxJM-keFeKEqXrnziw',
  },
  firebase: {
    apiKey: "AIzaSyDwWXPdtot-NAJzTuk3B8FOzTLNSMySMqM",
    authDomain: "coeur-d-alene.firebaseapp.com",
    projectId: "coeur-d-alene",
    storageBucket: "coeur-d-alene.appspot.com",
    messagingSenderId: "674055924744",
    appId: "1:674055924744:web:39901604a7cf8e1d1035bd",
    measurementId: "G-755NMKHR29"
  },
  messagesSDK: {
    client_id: 1634,
    client_secret: 'kzrEwm73X0Gm8-H9I7nQ5w',
    base_url: 'https://pushapi.mobimanage.com'
  },
  socialWall: {
    client_id: '2266',
    client_secret: 'uzf6u8KSB3rShbLLTqZUyrGKB4AJZ4vHB7Xfk2ksa12=',
    url: 'https://wall.crowdriff.com/live/24206c2e-3bba-407a-b649-8abd93f1b40b'
  },
  googleMaps: 'AIzaSyAb0SnmmZsewjJYWVDY5U3D8-oo1zKh-Jg',
  google: {
    client_id: '674055924744-ue9kir0ugbqdmcc7ethdeg0rf7rgvuuj.apps.googleusercontent.com',
  },
  facebook: {
    app_id: '3835662490085936',
    version: 'v21.0'
  },
  batuta: {
    api_key: 'e8e98196453d6f0bd4ffd6553d56a829',
    base_url: 'http://battuta.medunes.net/api/'
  },
  tokenUniversal: {
    token: "DWuAh7qPqHqyp8la7Os4568OuHLu6dbpyvo11ZtsIfPvAnQgZOEPQk9Ssqdlb42VqVI"
  },
  ItineraryBuilder:{
    base_url: 'https://cda-ib.trueomni.com'
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
